import { ZodFlattenedError } from 'zod';

export class SchemaValidationError extends Error {
  constructor(
    endpoint: string,
    public schemaError: ZodFlattenedError<
      any,
      {
        message: string;
        errorCode?: string;
        path?: PropertyKey[];
      }
    >
  ) {
    super(endpoint);
    this.name = 'SchemaValidationError';
  }
}
